/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ServiceApi } from '../api/service.api';
import { switchMap, map } from 'rxjs/operators';
import { ServiceData, Service, BranchSrvc } from '../../../interfaces/masters/service';

@Injectable()
export class ServiceService extends ServiceData {

  constructor(private api: ServiceApi) {
    super();
  }
  searchList(url: string, data:any): Observable<any[]> {
    return this.api.searchList(url,data);
  }

  list(url: string): Observable<Service[]> {
    return this.api.list(url);
  }
  
  serviceDetailList(url: string): Observable<any[]> {
    return this.api. list(url);
  }

  getById(url:string): Observable<Service>{
      return this.api.getById(url);
  }

  create(url: string, data:Service): Observable<Service> {
    return this.api.add(url,data);
  }
  patch(url: string, data:Service): Observable<Service> {
    return this.api.patch(url,data);
  }
  createServiceDetail(url: string, data:any): Observable<any> {
    return this.api.addServiceDetail(url,data);
  }
  updateBranchSrvc(url: string, data:BranchSrvc): Observable<any> {
    return this.api.updateBranchSrvc(url,data);
  }

  updateBranchFields(url: string,data: any): Observable<any> {
    return this.api.updateBranchFields(url, data);
  }

  update(url: string, data:Service): Observable<Service> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
